import * as React from 'react';
import { Environment } from '../../../const/environment';

type NoContentViewProps = {
    label: string,
    img: string,
    mode?: string;
    environment?: Environment;
    action?: () => void,
    btnLabel?: string;
};

function NoContentView({ label, img, action, btnLabel, mode, environment }: NoContentViewProps) {
    return (
        <div className={`no-content-view ${mode} ${environment}`}>
            <img className="no-content-view_img" src={img} />
            <div className="no-content-view_text">
                {label}
                {action &&
                    <div
                        className="no-content-view_btn action-btn big only-btn"
                        onClick={action}>
                        {btnLabel}
                    </div>
                }
            </div>
        </div>
    );
}

export default NoContentView;